import axios from "axios";
import { useCallback, useEffect, useState } from "react";

// Fetches Channel Manager mappings and groups them by room + rate plan so
// RatePlansManagement can show "N Connections" and per-channel rate rows
// under each rate plan, without touching how the base rate itself is
// computed/stored (see backend/handler/channelManager/syncRoomHandler).
export const useChannelMappings = () => {
  const [mappingsByRoomAndPlan, setMappingsByRoomAndPlan] = useState({});

  const fetchMappings = useCallback(async () => {
    try {
      const res = await axios.get("/api/channelmanager/mappings");
      const grouped = {};
      res.data.forEach((mapping) => {
        const roomId = mapping.room?._id || mapping.room;
        const ratePlanId = mapping.ratePlan?._id || mapping.ratePlan;
        if (!roomId || !ratePlanId) return;
        grouped[roomId] = grouped[roomId] || {};
        grouped[roomId][ratePlanId] = grouped[roomId][ratePlanId] || [];
        grouped[roomId][ratePlanId].push(mapping);
      });
      setMappingsByRoomAndPlan(grouped);
    } catch (error) {
      console.error("Failed to fetch channel mappings:", error.message);
    }
  }, []);

  useEffect(() => {
    fetchMappings();
  }, [fetchMappings]);

  return { mappingsByRoomAndPlan, fetchMappings };
};
